import React from "react";
import { Tag } from "antd";

// Trạng thái link video. status: alive | dead | unknown
const META = {
    alive: { color: "green", label: "Còn xem được" },
    dead: { color: "red", label: "Đã gỡ / chết" },
    unknown: { color: "default", label: "Chưa kiểm tra" },
};

function VideoStatusTag({ status }) {
    const m = META[status] || META.unknown;
    return <Tag color={m.color}>{m.label}</Tag>;
}

export default VideoStatusTag;
